import { YOO_FINDS_CDN } from "@/common";

const ROOT = `${YOO_FINDS_CDN}/h5/holiday/midyear-sale`;

export const MIDYEAR_SALE_BANNER = `${ROOT}/banner-v2.png?imageMogr2/thumbnail/!60p`;
export const MIDYEAR_SALE_BG = `${ROOT}/bg.webp`;
